export type DeleteUserRolesRequest = {
  userRoles: {
    idx: number;
    userId: string;
    roleCd: string;
    cvrgCd: string;
    updateDateTime: string;
  }[];
};
